
import { Options, Vue } from "vue-property-decorator";

@Options({
  props: {
    label: String,
  },
  components: {}
})
export default class Tag extends Vue {
  private label?: string;
}

